/**
 * Prefer the UI page size, but never exceed a connection's configured maxPageSize.
 * Keep in sync with `next/lib/hooks/utils.ts` (same GraphQL endpoint).
 */
export const getEffectivePageSize = (pageSize: number, maxPageSize?: number | null) => {
  if (maxPageSize == null || maxPageSize <= 0) return pageSize
  return Math.min(pageSize, maxPageSize)
}

/**
 * Page variables for Bauclub Relay connections with the custom `offset` argument.
 * Uses the effective page size so offsets stay aligned when max_page_size clamps first.
 *
 * @param currentPage 0-based page index
 */
export const getPageVariables = (
  currentPage: number,
  pageSize: number,
  maxPageSize?: number | null
) => {
  const effectivePageSize = getEffectivePageSize(pageSize, maxPageSize)

  return {
    first: effectivePageSize,
    offset: currentPage * effectivePageSize
  }
}

/**
 * Same as getPageVariables, but for klarxMANAGER's 1-based page numbers.
 */
export const getPageVariablesFromOneBasedPage = (
  currentPage: number,
  pageSize: number,
  maxPageSize?: number | null
) => getPageVariables(Math.max(currentPage - 1, 0), pageSize, maxPageSize)
